// extracted by mini-css-extract-plugin
export var closeButton = "_15-3";
export var header = "_15-0";
export var link = "_15-1";
export var retryButton = "_15-2";